import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Constants } from '../lib/const/constants';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import getCurrencySymbol from '../lib/currenyUtils';
import Papa from 'papaparse';
import { encryptPayload } from '../utils/encryption';

const today = new Date();
const lastmonth = new Date();
lastmonth.setMonth(today.getMonth() - 1);

const formatDate = (date) => date.toISOString().split('T')[0];

const styles = {
  page: {
    minHeight: '100vh',
    padding: '32px 40px',
    backgroundColor: '#ffffff',
    backgroundImage:
      'linear-gradient(180deg,rgba(248,250,252,1) 0%,rgba(239,246,255,0.3) 50%,rgba(238,242,255,0.4) 100%)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
  },
  pageTitle: {
    fontSize: 24,
    fontWeight: 700,
    color: '#394784',
    textAlign: 'center',
    marginBottom: 4,
  },
  card: {
    borderRadius: 16,
    border: '1px solid #F2F2F2',
    background: '#FFFFFF',
    boxShadow: '0px 4px 16px rgba(0,0,0,0.06)',
    padding: 24,
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: 960,
    margin: '0 auto',
  },
  innerBox: {
    borderRadius: 12,
    border: '1px solid #E6E5E5',
    background: '#FCFCFC',
    padding: 24,
    boxSizing: 'border-box',
  },
  label: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    fontSize: 14,
    fontWeight: 400,
    color: '#676F7D',
    width: 180,
    flexShrink: 0,
  },
  value: {
    fontSize: 14,
    fontWeight: 600,
    color: '#1D2338',
    wordBreak: 'break-word',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 700,
    color: '#0B214E',
    marginBottom: 16,
  },
  uploadZone: {
    width: 672,
    height: 193.2,
    border: '1.5px dashed #E6E5E5',
    borderRadius: 16,
    background: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '33.6px',
    gap: 8,
    cursor: 'pointer',
    transition: 'border-color 0.2s, background 0.2s',
  },
  uploadTitle: {
    fontSize: 15,
    fontWeight: 600,
    color: '#0B214E',
  },
  uploadSub: {
    fontSize: 13,
    color: '#9CA3AF',
  },
  orangeBtn: {
    width: '100%',
    padding: '14px 0',
    background: '#D26521',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: 10,
    fontSize: 15,
    fontWeight: 700,
    cursor: 'pointer',
    boxShadow: '0px 4px 24px rgba(157,79,26,0.36)',
    transition: 'background 0.2s',
    letterSpacing: 0.3,
  },
  outlineBtn: {
    padding: '10px 22px',
    background: 'transparent',
    color: '#D26521',
    border: '2px solid #D26521',
    borderRadius: 10,
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background 0.2s, color 0.2s',
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  historyBtn: {
    padding: '10px 20px',
    background: '#D26521',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: 10,
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    boxShadow: '0px 4px 24px rgba(157,79,26,0.26)',
    whiteSpace: 'nowrap',
  },
  searchInput: {
    flex: 1,
    padding: '10px 16px',
    border: '1px solid #E6E5E5',
    borderRadius: 10,
    fontSize: 14,
    color: '#1D2338',
    background: '#FCFCFC',
    outline: 'none',
  },
  statusBadge: (status) => ({
    padding: '4px 14px',
    borderRadius: 20,
    fontSize: 12,
    fontWeight: 600,
    background:
      status === 'Settled' || status === 'settled'
        ? '#D1FAE5'
        : status === 'Failed' || status === 'failed'
          ? '#FEE2E2'
          : '#FEF3C7',
    color:
      status === 'Settled' || status === 'settled'
        ? '#065F46'
        : status === 'Failed' || status === 'failed'
          ? '#991B1B'
          : '#92400E',
  }),
  fileRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    padding: '14px 0',
    borderBottom: '1px solid #F2F2F2',
  },
  fileIcon: {
    width: 48,
    height: 48,
    borderRadius: '26843500px',
    background: '#EFF4FF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  dateLbl: { fontSize: 14, fontWeight: 400, color: '#6A7282', marginTop: 2 },
  idLbl: {
    display: 'inline-block',
    marginTop: 4,
    fontSize: 11,
    color: '#676F7D',
    background: '#F3F4F6',
    borderRadius: 6,
    padding: '2px 8px',
  },
  toggleTrack: (checked) => ({
    width: 44,
    height: 24,
    borderRadius: 12,
    background: checked ? '#155DFC' : '#D1D5DB',
    position: 'relative',
    cursor: 'pointer',
    transition: 'background 0.2s',
    flexShrink: 0,
  }),
  toggleThumb: (checked) => ({
    position: 'absolute',
    top: 4,
    left: checked ? 24 : 4,
    width: 16,
    height: 16,
    borderRadius: '50%',
    background: '#FFFFFF',
    transition: 'left 0.2s',
    boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
  }),
  dateInput: {
    padding: '9px 14px',
    border: '1px solid #E6E5E5',
    borderRadius: 10,
    fontSize: 14,
    color: '#1D2338',
    background: '#FCFCFC',
    outline: 'none',
  },
  searchBtn: {
    padding: '10px 28px',
    background: '#0B214E',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: 10,
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background 0.2s',
    whiteSpace: 'nowrap',
  },
};

const AVATAR_COLORS = [
  { bg: '#6B84D4', text: '#FFFFFF' },
  { bg: '#D4A043', text: '#FFFFFF' },
  { bg: '#9B6FD4', text: '#FFFFFF' },
  { bg: '#3DA882', text: '#FFFFFF' },
  { bg: '#D46B6B', text: '#FFFFFF' },
  { bg: '#3DA8C4', text: '#FFFFFF' },
];

const COL = {
  PAYMENT_TYPE: 0,
  BANK_ACCOUNT_NAME: 1,
  BANK_ACCOUNT_NUMBER: 2,
  BANK_CODE_TYPE: 3,
  BANK_CODE: 4,
  BANK_COUNTRY: 5,
  CURRENCY: 6,
  PAYMENT_AMOUNT: 7,
  PAYMENT_REASON: 8,
  BENEFICIARY_ADDRESS: 9,
  MOBILE: 10,
  FIRST_NAME: 11,
  LAST_NAME: 12,
  COMPANY_NAME: 13,
  DATE_OF_BIRTH: 14,
};

function PaginationControls({ currentPage, totalPages, onPageChange }) {
  const getPages = () => {
    if (totalPages <= 3) return Array.from({ length: totalPages }, (_, i) => i + 1);
    if (currentPage === 1) return [1, 2, 3];
    if (currentPage === totalPages) return [totalPages - 2, totalPages - 1, totalPages];
    return [currentPage - 1, currentPage, currentPage + 1];
  };

  const pages = getPages();

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 6, marginTop: 12, paddingTop: 12, borderTop: '1px solid #F2F2F2' }}>
      <button
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
        style={{ width: 32, height: 32, borderRadius: 6, border: '1px solid #E6E5E5', background: '#FFFFFF', cursor: currentPage === 1 ? 'not-allowed' : 'pointer', opacity: currentPage === 1 ? 0.4 : 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M15 18l-6-6 6-6" stroke="#1D2338" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>

      {pages[0] > 1 && (
        <>
          <button onClick={() => onPageChange(1)} style={{ width: 32, height: 32, borderRadius: 6, border: '1px solid #E6E5E5', background: '#FFFFFF', color: '#1D2338', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'Inter, sans-serif' }}>1</button>
          {pages[0] > 2 && <span style={{ fontSize: 13, color: '#9CA3AF' }}>...</span>}
        </>
      )}

      {pages.map((page) => (
        <button
          key={page}
          onClick={() => onPageChange(page)}
          style={{ width: 32, height: 32, borderRadius: 6, border: '1px solid', borderColor: currentPage === page ? '#0B214E' : '#E6E5E5', background: currentPage === page ? '#0B214E' : '#FFFFFF', color: currentPage === page ? '#FFFFFF' : '#1D2338', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'Inter, sans-serif' }}
        >
          {page}
        </button>
      ))}

      {pages[pages.length - 1] < totalPages && (
        <>
          {pages[pages.length - 1] < totalPages - 1 && <span style={{ fontSize: 13, color: '#9CA3AF' }}>...</span>}
          <button onClick={() => onPageChange(totalPages)} style={{ width: 32, height: 32, borderRadius: 6, border: '1px solid #E6E5E5', background: '#FFFFFF', color: '#1D2338', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'Inter, sans-serif' }}>{totalPages}</button>
        </>
      )}

      <button
        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
        style={{ width: 32, height: 32, borderRadius: 6, border: '1px solid #E6E5E5', background: '#FFFFFF', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', opacity: currentPage === totalPages ? 0.4 : 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M9 18l6-6-6-6" stroke="#1D2338" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
    </div>
  );
}
PaginationControls.propTypes = { currentPage: PropTypes.number, totalPages: PropTypes.number, onPageChange: PropTypes.func };

function UploadedDataRow({ item, index }) {
  const color = AVATAR_COLORS[index % AVATAR_COLORS.length];
  const firstName = item[COL.FIRST_NAME] || '';
  const lastName = item[COL.LAST_NAME] || '';
  const companyName = item[COL.COMPANY_NAME] || '';
  const paymentType = item[COL.PAYMENT_TYPE] || '';
  const isCompany = paymentType.toLowerCase() === 'business' || paymentType.toLowerCase() === 'corporate';
  const displayName = isCompany ? companyName : `${firstName} ${lastName}`.trim();
  const initial = displayName.charAt(0).toUpperCase() || '?';
  const currency = item[COL.CURRENCY] || '';
  const accountNumber = item[COL.BANK_ACCOUNT_NUMBER] || '';
  const bankCodeType = item[COL.BANK_CODE_TYPE] || '';
  const bankCode = item[COL.BANK_CODE] || '';
  const paymentAmount = item[COL.PAYMENT_AMOUNT] || '';
  const dob = item[COL.DATE_OF_BIRTH] || '';
  const beneficiaryName = `${firstName} ${lastName}`.trim() || companyName;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '16px 0',
        borderBottom: '1px solid #F2F2F2',
        gap: 14,
      }}
    >
      {/* Avatar */}
      <div
        style={{
          width: 44,
          height: 44,
          borderRadius: '50%',
          background: color.bg,
          color: color.text,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 700,
          fontSize: 18,
          flexShrink: 0,
          fontFamily: "'Inter', sans-serif",
        }}
      >
        {initial}
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 2 }}>
          <span style={{ fontSize: 16, fontWeight: 600, color: '#1D2338' }}>{displayName}</span>
          {currency && (
            <span style={{ fontSize: 14, fontWeight: 400, color: '#1D2338' }}>
              {currency}
            </span>
          )}
        </div>

        <div style={{ fontSize: 12, fontWeight: 400, color: '#676F7D', marginBottom: 8 }}>
          Account Number/ IBAN :{' '}
          <span style={{ color: '#1D2338', fontWeight: 400, fontSize: 12 }}>{accountNumber}</span>
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {paymentType && (
            <span style={tagStyle}>
              Account Type: <strong style={{ color: '#1D2338', fontWeight: 500, fontSize: 12 }}>{paymentType}</strong>
            </span>
          )}
          {bankCodeType && bankCode && (
            <span style={tagStyle}>
              {bankCodeType==='sort_code'?'Sort Code':bankCodeType}: <strong style={{ color: '#1D2338', fontWeight: 500, fontSize: 12 }}>{bankCode}</strong>
            </span>
          )}
          {beneficiaryName && (
            <span style={tagStyle}>
              Beneficiary Name: <strong style={{ color: '#1D2338', fontWeight: 500, fontSize: 12 }}>{beneficiaryName}</strong>
            </span>
          )}
          {dob && (
            <span style={tagStyle}>
              Date of Birth: <strong style={{ color: '#1D2338', fontWeight: 600 }}>{dob}</strong>
            </span>
          )}
        </div>
      </div>

      <div style={{ textAlign: 'right', flexShrink: 0 }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: '#203358' }}>
          {currency} {parseFloat(paymentAmount || 0).toFixed(2)}
        </div>
        <div style={{ fontSize: 12, fontWeight: 400, color: '#6A7282', marginTop: 2 }}>Payment Amount</div>
      </div>
    </div>
  );
}
UploadedDataRow.propTypes = { item: PropTypes.any, index: PropTypes.number };

const tagStyle = {
  fontSize: 12,
  fontWeight: 400,
  color: '#676F7D',
  background: '#F6F6FB',
  borderRadius: 6,
  padding: '3px 10px',
  whiteSpace: 'nowrap',
};

// const getBankIcon = (media = []) => {
//   return media.find((item) => item.type === 'icon')?.source;
// };

function BulkUpload() {
  const navigate = useNavigate();

  const [file, setFile] = useState();
  const [uploading, setUploading] = useState(false);
  const [fileName, setfileName] = useState('');
  const [transactions, settransactions] = useState([]);
  const [showOverView, setshowOverView] = useState(false);
  const [totalRecords, settotalRecords] = useState();
  const [totalPayment, settotalPayment] = useState();
  const [uniqueId, setuniqueId] = useState();
  const reference = useRef(null);
  const [balanceLoading, setBalanceLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [downloadId, setDownloadId] = useState();
  const [, setUsedBalances] = useState([]);
  const [clearBankBalance, setclearBankBalance] = useState(0.0);
  const [currencyCloudBalance, setcurrencyCloudBalance] = useState(0.0);
  const [bulkUploadDocuments, setBulkUploadDocuments] = useState([]);
  const [availableBalances, setAvailableBalances] = useState(0);
  const [isUploadProceedDisabled, setIsUploadProceedDisabled] = useState(false);

  const [fromDate, setFromDate] = useState(formatDate(lastmonth));
  const [toDate, setToDate] = useState(formatDate(today));
  const [dropDownStatus, setDropDownStatus] = useState('All');

  const [, setclearBankConfiguration] = useState();
  const [searchPerformed, setSearchPerformed] = useState(false);
  const [, setErrors] = useState([]);
  const [referral,] = useState('');

  const [, setUploadTransactions] = useState([]);
  const fileInputRef = useRef(null);
  // const [selectedBank] = useState(null);
  const [, setBanks] = useState([]);

  const [scheduled_timestamp, setscheduled_timestamp] = useState('');
  const [isChecked, setIsChecked] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const [transactionPage, setTransactionPage] = useState(1);
  const TRANSACTIONS_PAGE_SIZE = 5;

  const [docsPage, setDocsPage] = useState(1);
  const DOCS_PAGE_SIZE = 4;

  // console.log(banks, selectedBank, error, usedBalances, clearBankConfiguration);

  useEffect(() => {
    axios
      .get(Constants.REPORTS_BASE_URL + 'volt/banks')
      .then((r) => setBanks(r.data))
      .catch((e) => console.error(e));
    getBalances();
  }, []);

  const getBalances = async () => {
    if (balanceLoading) return;
    setBalanceLoading(true);
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    const login_token = sessionStorage.getItem('login_token');
    if (!login_workspaces_id) {
      const staff_login_id = sessionStorage.getItem('staff_login_id');
      if (!staff_login_id) navigate('/business');
      else navigate('/DebitTransactions');
    } else {
      try {
        const resp = await axios.get(
          Constants.BASE_URL +
          'API-FX-231-GET-WALLET-BALANCES/' +
          login_workspaces_id +
          '?currency=GBP',
          {
            headers: {
              Authorization: 'Bearer ' + JSON.parse(login_token),
              fx_key: Constants.SUBSCRIPTION_KEY,
            },
          },
        );
        const balArray = Object.values(resp.data);
        setUsedBalances(resp.data.used_balances);
        balArray.pop();
        setcurrencyCloudBalance(resp.data.currency_cloud_account_balance);
        setclearBankBalance(resp.data.clear_bank_account_balance);
        setclearBankConfiguration(resp.data.fees_configuration);
        balArray.pop();
        balArray.pop();
        balArray.pop();
        const gbpBalance = balArray.find((b) => b.currency === 'GBP');
        const mainBalance = gbpBalance ? gbpBalance.balance : 0;
        const used = resp.data.used_balances.GBP ? resp.data.used_balances.GBP : 0;
        const avail = parseFloat(mainBalance - used).toFixed(2);
        setAvailableBalances(avail < 0 ? 0.0 : avail);
      } catch (err) {
        console.log(err.response?.data || err.message);
      } finally {
        setBalanceLoading(false);
      }
    }
  };

  const NEW_REQUIRED_HEADERS = [
    'Payment_Type', 'Bank_Account_Name', 'Bank_Account_Number', 'Bank_Code_Type', 'Bank_Code',
    'Bank_Country', 'Currency', 'Payment_Amount', 'Payment_Reason', 'Beneficiary_Address',
    'Mobile_Number', 'Beneficiary_FirstName', 'Beneficiary_LastName', 'Company_Name', 'Date_Of_Birth',
  ];
  const OLD_HEADERS = [
    'type', 'first_name', 'last_name', 'reason', 'amount', 'mobile', 'bank_country_name',
    'bank_code_type', 'bank_account_name', 'code', 'bank_account_number', 'beneficiary_address',
    'company_name', 'currency', 'date_of_birth',
  ];

  const handleSingleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    if (fileInputRef.current) fileInputRef.current.value = '';
    setErrors([]); settransactions([]); setshowOverView(false);
    setfileName(''); setUploadTransactions([]); setFile(null);
    if (file.type !== 'text/csv' && !file.name.endsWith('.csv')) {
      toast.error('Only CSV files are allowed.'); return;
    }
    if (file.size > 50 * 1024 * 1024) {
      toast.error('File size should not exceed 50MB.'); return;
    }
    const norm = (h = '') => h.toLowerCase().replace(/[\s-]+/g, '_').trim();
    Papa.parse(file, {
      header: true, skipEmptyLines: true,
      complete(results) {
        const rows = results.data || [];
        const headers = (results.meta?.fields || []).map(norm);
        const normNew = NEW_REQUIRED_HEADERS.map(norm);
        const normOld = OLD_HEADERS.map(norm);
        if (!rows.some((r) => Object.values(r).some((v) => String(v).trim()))) {
          toast.error('No data found in the file.'); return;
        }
        if (headers.length === normOld.length && normOld.every((h) => headers.includes(h))) {
          toast.error('Invalid CSV format or invalid file.'); return;
        }
        if (!normNew.some((h) => headers.includes(h))) {
          const e = [{ lineNo: '-', row: null, messages: 'Invalid CSV format or headers do not match required template.' }];
          setErrors(e); navigate('/bulk-upload-csv-error-preview', { state: { errors: e } }); return;
        }
        const missing = normNew.filter((h) => !headers.includes(h));
        if (missing.length) {
          const e = [{ lineNo: '-', row: null, messages: `Missing required columns: ${missing.join(', ')}` }];
          setErrors(e); navigate('/bulk-upload-csv-error-preview', { state: { errors: e } }); return;
        }
        const extra = headers.filter((h) => !normNew.includes(h));
        if (extra.length) {
          const e = [{ lineNo: '-', row: null, messages: `Extra column(s) found: ${extra.join(', ')}` }];
          setErrors(e); navigate('/bulk-upload-csv-error-preview', { state: { errors: e } }); return;
        }
        const rowErrors = validateCSV(rows);
        setUploadTransactions(rows); setFile(file); setfileName(file.name);
        if (rowErrors.length) {
          setErrors(rowErrors);
          navigate('/bulk-upload-csv-error-preview', { state: { errors: rowErrors } });
        }
      },
      error() { toast.error('Failed to parse CSV file.'); },
    });
  };

  const validateCSV = (rows) => {
    const errors = [];
    const normType = (v = '') => v.toLowerCase().replace(/[\s-]+/g, '_');
    const str = (v) => (v ?? '').toString().trim();
    const isEmpty = (row) => Object.values(row || {}).every((v) => str(v) === '');
    const allowed = ['sort_code', 'bsb_code', 'institution_no', 'bank_code', 'branch_code', 'aba', 'clabe', 'cnaps', 'ifsc', 'bic'];
    if (!rows.some((r) => !isEmpty(r))) {
      toast.error('The uploaded file contains only headers and no data.');
      return [{ lineNo: '-', row: null, messages: 'The uploaded file contains only headers and no data.' }];
    }
    rows.forEach((row, i) => {
      const lineNo = i + 2; const rowErrors = []; const add = (m) => rowErrors.push(m);
      if (isEmpty(row)) { add('Row is Empty'); errors.push({ lineNo, row, messages: rowErrors.join('\n') }); }
      if (str(row.Bank_Account_Name) === '') add('Invalid bank account name');
      if (!/^\d{6,18}$/.test(str(row.Bank_Account_Number))) add('Invalid bank account number');
      const code = str(row.Bank_Code).replace(/\s+/g, '').toUpperCase();
      const types = str(row.Bank_Code_Type).split(/[\s,]+/).map(normType).filter((t) => allowed.includes(t));
      let type = null;
      if (!types.length) add('Invalid bank code type');
      else if (types.length > 1) add('Multiple bank code types provided; only one allowed');
      else type = types[0];
      if (type) {
        const checks = {
          sort_code: /^\d{6}$/, bsb_code: /^\d{6}$/, institution_no: /^\d{3}$/,
          bank_code: /^\d{3,5}$/, branch_code: /^\d{3,6}$/, aba: /^\d{9}$/, clabe: /^\d{18}$/,
          cnaps: /^\d{12}$/, ifsc: /^[A-Z]{4}0\d{6}$/, bic: /^[A-Z0-9]{8}([A-Z0-9]{3})?$/i,
        };
        if (checks[type] && !checks[type].test(code)) add(`Invalid ${type.replace(/_/g, ' ')}`);
      }
      if (!/^[A-Za-z ]{2,}$/.test(str(row.Bank_Country))) add('Invalid bank country name');
      if (!/^[A-Z]{3}$/.test(str(row.Currency))) add('Invalid currency code');
      const amt = str(row.Payment_Amount);
      if (!/^\d+(\.\d+)?$/.test(amt) || Number(amt) <= 0) add('Invalid Payment amount');
      if (!/^[A-Za-z0-9- ]+$/.test(str(row.Payment_Reason))) add('Invalid Payment reason');
      if (rowErrors.length) {
        const cleanRow = { ...row };
        if (type) { cleanRow.Bank_Code_Type = type; cleanRow.Bank_Code = code; }
        errors.push({ lineNo, row: cleanRow, messages: rowErrors.join('\n ') });
      }
    });
    return errors;
  };

  const getBase64 = (file, cb) => {
    const r = new FileReader();
    r.readAsDataURL(file);
    r.onload = () => cb(r.result);
    r.onerror = (e) => console.log('Error:', e);
  };

  function handleSubmit() {
    if (!file) { toast.error('Please upload file.'); return; }
    if (isChecked && !scheduled_timestamp) { toast.error('Please select the scheduled time.'); return; }
    if (isChecked && new Date(scheduled_timestamp) <= new Date()) {
      toast.error('Scheduled time must be in the future.');
      return;
    }
    setUploading(true);
    getBase64(file, (result) => uploadSingleDocument(result));
  }

  function UploadedDataList() {
    const totalTxPages = Math.ceil(transactions.length / TRANSACTIONS_PAGE_SIZE);
    const visibleItems = transactions.slice(
      (transactionPage - 1) * TRANSACTIONS_PAGE_SIZE,
      transactionPage * TRANSACTIONS_PAGE_SIZE,
    );
    function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } 
    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 0, marginBottom: 20 }}>
          <div
            style={{
              border: '1px solid #E6E5E5',
              borderRadius: '10px 0 0 10px',
              padding: '10px 28px',
              fontSize: 14,
              fontWeight: 400,
              color: '#676F7D',
              borderRight: 'none',
              height: 44,
            }}
          >
            Available Balance:{' '}
            <strong style={{ color: '#101828' }}>
              {getCurrencySymbol('GBP')} {numberWithCommas(availableBalances)}
            </strong>
          </div>
          <div
            style={{
              border: '1px solid #E6E5E5',
              borderRadius: '0 10px 10px 0',
              padding: '10px 28px',
              fontSize: 14,
              color: '#676F7D',
              height: 44,
              fontWeight: 400,
            }}
          >
            Uploaded Amount:{' '}
            <strong style={{ color: '#101828' }}>
              {getCurrencySymbol('GBP')} {parseFloat(totalPayment).toFixed(2)}
            </strong>
          </div>
        </div>

        <div>
          {visibleItems.map((item, index) => (
            <UploadedDataRow key={index} item={item} index={index} />
          ))}
        </div>

        {totalTxPages > 1 && (
          <PaginationControls
            currentPage={transactionPage}
            totalPages={totalTxPages}
            onPageChange={setTransactionPage}
          />
        )}
      </div>
    );
  }

  const uploadSingleDocument = async (document) => {
    const token = sessionStorage.getItem('login_token');
    const staff_login_id = sessionStorage.getItem('staff_login_id');
    const encryptedPayload = await encryptPayload({
          file: document, fileName, staff_login_id, currency_cloud_balance: currencyCloudBalance,
          clear_bank_balance: clearBankBalance, total_balance: availableBalances,
          totalRecords, totalPayment, referralname: referral,platform:'web',extraParamValidation: 'trustedfromweb'
        });
    await axios
      .post(
        Constants.BASE_URL + 'API-FX-195-BULK-UPLOAD-DOCUMENTS-TRANSACTIONS',
        encryptedPayload
        ,
        { headers: { Authorization: 'Bearer ' + JSON.parse(token), fx_key: Constants.SUBSCRIPTION_KEY } },
      )
      .then((response) => {
        if (response.data.status == 200) {
          settransactions(response.data.uploaded_transactions);
          settotalRecords(response.data.totalTransactions);
          settotalPayment(response.data.totalAmount);
          sessionStorage.setItem('bulk_unique_id', response.data.uniqueId);
          setuniqueId(response.data.uniqueId);
          if (response.data.totalAmount > availableBalances) {
            setIsUploadProceedDisabled(true);
            toast.error('Insufficient funds to complete the bulk upload.');
          }
        } else toast.error(response.data.message);
        setUploading(false);
        reference.current.value = '';
      })
      .catch(() => { toast.error('Something went wrong. Please try again later.'); setUploading(false); });
  };

  function OverView() {
    return (
      <>
        <div style={{ ...styles.innerBox, marginTop: 16 }}>
          {[['Total Payments', totalRecords], ['Total Amount', parseFloat(totalPayment).toFixed(2)]].map(([lbl, val]) => (
            <div key={lbl} style={{ ...styles.row, padding: '10px 0' }}>
              <span style={styles.label}>{lbl}</span>
              <span style={styles.value}>{val}</span>
            </div>
          ))}
        </div>
      </>
    );
  }

  const confirmUpload = async () => {
    setUploading(true);
    const token = sessionStorage.getItem('login_token');
    const encryptedPayload = await encryptPayload({
          uniqueId, fileName, totalRecords, totalPayment,
          scheduled_timestamp: convertToUKTime(scheduled_timestamp), selected_timestamp: scheduled_timestamp,
          platform: 'web',
              extraParamValidation: 'trustedfromweb'
        });

    await axios
      .post(
        Constants.BASE_URL + 'API-FX-212-BULK-UPLOAD-CONFIRM',
        encryptedPayload,
        { headers: { Authorization: 'Bearer ' + JSON.parse(token), fx_key: Constants.SUBSCRIPTION_KEY } },
      )
      .then((resp) => {
        if (resp.data.status == '200') {
          toast.success(resp.data.message);
          setTimeout(() => navigate('/', { state: { qr_login_completed: 1 } }), 2000);
        } else toast.error(resp.data.message);
        setUploading(false);
      })
      .catch(() => { toast.error('Something went wrong. Please try again later.'); setUploading(false); });
  };

  const formatToMMDDYYYY = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return '';
    return `${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}/${d.getFullYear()}`;
  };

  const searchBulkUploadDocs = async () => {
    if (!fromDate || !toDate) { toast.error('Please select both From and To dates'); return; }
    setSearchPerformed(true);
    setDocsPage(1);
    const from = new Date(fromDate), to = new Date(toDate);
    if (isNaN(from.getTime()) || isNaN(to.getTime())) { toast.error('Invalid date format'); return; }
    if (to < from) { toast.error('To Date cannot be before From Date'); return; }
    if (to > today) { toast.error('To Date cannot be in the future'); return; }
    setSearchLoading(true);
    try {
      const login_token = sessionStorage.getItem('login_token');
      const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
      const fileNameParam  = searchQuery.trim()
  ? `&file_name=${encodeURIComponent(searchQuery.trim())}`
  : '';
      const response = await axios.get(
        `${Constants.BASE_URL}API-FX-224-GET-BULK-UPLOAD-DOCUMENTS/${login_workspaces_id}?from_date=${formatToMMDDYYYY(fromDate)}&to_date=${formatToMMDDYYYY(toDate)}${fileNameParam}`,
        { headers: { fx_key: Constants.SUBSCRIPTION_KEY, Authorization: `Bearer ${JSON.parse(login_token)}` } },
      );
      setBulkUploadDocuments(response.data);
    } catch (err) {
      console.error(err.response); toast.error('Failed to fetch documents');
    } finally { setSearchLoading(false); }
  };

  const downloadDocument = async (id) => {
    setDownloadLoading(true); setDownloadId(id);
    const login_token = sessionStorage.getItem('login_token');
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    await axios
      .post(
        Constants.BASE_URL + 'API-FX-225-BULK-UPLOAD-TRANSACTION-DOWNLOAD/' + login_workspaces_id,
        { id, status: dropDownStatus },
        { headers: { fx_key: Constants.SUBSCRIPTION_KEY, Authorization: 'Bearer ' + JSON.parse(login_token) } },
      )
      .then((resp) => {
        setBulkUploadDocuments([]); searchBulkUploadDocs();
        window.open(Constants.FXMASTER_BASE_URL + resp.data.path);
        setDownloadLoading(false);
      })
      .catch(() => { toast.error('No Data Found'); setDownloadLoading(false); });
  };

  const convertToUKTime = (localDateTime) => {
    if (!localDateTime) return '';

    let date;
    date = new Date(localDateTime.replace(' ', 'T') + 'Z');
    if (localDateTime instanceof Date) {
      date = localDateTime;
    } else if (typeof localDateTime === 'string') {
      if (localDateTime.includes(' ')) {
        const [d, t] = localDateTime.split(' ');
        if (!d || !t) return '';

        const [y, m, da] = d.split('-');
        const [h, mi, s] = t.split(':');

        // Create as UTC to avoid timezone shift
        date = new Date(Date.UTC(y, m - 1, da, h, mi, s));
      } else {
        date = new Date(localDateTime);
      }
    } else if (typeof localDateTime === 'number') {
      date = new Date(localDateTime);
    } else {
      return '';
    }

    if (!date || isNaN(date.getTime())) return '';

    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(date);

    const get = (type) => parts.find(p => p.type === type).value;

    const formatted = `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}`;

    return formatted;
  };

  console.log('BulkUploadDocuments test', bulkUploadDocuments);

  return (
    <div style={styles.page}>
      <ToastContainer />

      <div style={styles.pageTitle}>
        {transactions.length > 0 ? 'Uploaded Data' : 'Bulk Upload'}
      </div>

      {transactions.length > 0 && !showOverView && (
        <div style={{ textAlign: 'center', fontSize: 16, fontWeight: 500, color: '#676F7D', marginBottom: 4 }}>
          Confirm Bulk Payment
        </div>
      )}

      {transactions.length === 0 && (
        <div style={{ marginTop: 24, display: 'flex', justifyContent: 'center' }}>
          {balanceLoading ? (
            <div style={{ textAlign: 'center', padding: 24, color: '#676F7D' }}>Loading balances…</div>
          ) : (
            <div style={{ width: 720, display: 'flex', flexDirection: 'column' }}>

              <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
                <a
                  href="/testUpload.csv"
                  style={{ fontSize: 14, fontWeight: 500, color: '#306ACE', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 6 }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M12 15V3m0 12l-4-4m4 4l4-4M2 17l.621 2.485A2 2 0 004.561 21h14.878a2 2 0 001.94-1.515L22 17" stroke="#306ACE" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  Download Test File
                </a>
              </div>

              <div
                style={{ ...styles.uploadZone, width: '100%', boxSizing: 'border-box' }}
                onClick={() => reference.current?.click()}
              >
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                  <path d="M12 16V10m0 0l-3 3m3-3l3 3" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3-3 3" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span style={styles.uploadTitle}>Upload Attachment</span>
                <span style={styles.uploadSub}>Only CSV files are allowed (max. 50MB)</span>
                {fileName && (
                  <span style={{ fontSize: 13, color: '#10B981', fontWeight: 600, marginTop: 4 }}>
                    ✓ {fileName}
                  </span>
                )}
                <input
                  ref={(el) => { reference.current = el; fileInputRef.current = el; }}
                  type="file" accept=".csv"
                  onChange={handleSingleFileChange}
                  style={{ display: 'none' }}
                />
              </div>

              <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: 8 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer' }} onClick={() => setIsChecked((prev) => { if (prev) setscheduled_timestamp(''); return !prev; })}>
                  <div style={styles.toggleTrack(isChecked)}>
                    <div style={styles.toggleThumb(isChecked)} />
                  </div>
                  <span style={{ fontSize: 14, fontWeight: 600, color: '#1D2338' }}>Schedule Later</span>
                </div>
                {isChecked && (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8, paddingTop: 10 }}>
                    <input
                      type="datetime-local"
                      value={scheduled_timestamp}
                      min={new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 16)}
                      onChange={(e) => setscheduled_timestamp(e.target.value)}
                      style={{ ...styles.dateInput, width: 260 }}
                    />
                    {scheduled_timestamp && (
                      <p style={{ fontSize: 12, color: '#676F7D', margin: 0 }}>
                        Schedules after {((convertToUKTime(scheduled_timestamp)).split("T")).join(" ")} (BST)
                      </p>
                    )}
                  </div>
                )}
              </div>

              <div style={{ marginTop: 16 }}>
                <button
                  onClick={handleSubmit}
                  disabled={uploading}
                  style={{ ...styles.orangeBtn, width: '100%', opacity: uploading ? 0.6 : 1 }}
                >
                  {uploading ? 'Uploading…' : 'Upload'}
                </button>
              </div>

            </div>
          )}
        </div>
      )}

      {transactions.length > 0 && (
        <>
          <div style={{ ...styles.card, marginTop: 24, maxWidth: showOverView ? 672 : 960 }}>
            {showOverView ? <OverView /> : <UploadedDataList />}
          </div>

          <div
            style={{
              width: '100%',
              maxWidth: showOverView ? 672 : 960,
              margin: '16px auto 0',
              display: 'flex',
              gap: 12,
            }}
          >
            {showOverView ? (
              <button
                onClick={confirmUpload}
                disabled={uploading}
                style={{ ...styles.orangeBtn, opacity: uploading ? 0.6 : 1 }}
              >
                {uploading ? 'Confirming…' : 'Confirm to Upload'}
              </button>
            ) : (
              <>
                <button
                  onClick={() => {
                    setshowOverView(false); settransactions([]); setFile(null);
                    setfileName(''); setUploadTransactions([]); settotalPayment(''); settotalRecords('');
                    setTransactionPage(1);
                    if (fileInputRef.current) fileInputRef.current.value = '';
                  }}
                  style={{
                    flex: 1,
                    padding: '16px 0',
                    background: '#FFFFFF',
                    color: '#1D2338',
                    border: '1.5px solid #E6E5E5',
                    borderRadius: 10,
                    fontSize: 15,
                    fontWeight: 700,
                    cursor: 'pointer',
                    transition: 'background 0.2s',
                    letterSpacing: 0.3,
                    height: '56px',
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={() => setshowOverView(true)}
                  disabled={isUploadProceedDisabled}
                  style={{
                    flex: 1,
                    padding: '16px 0',
                    background: '#D26521',
                    color: '#FFFFFF',
                    border: 'none',
                    borderRadius: 10,
                    fontSize: 15,
                    fontWeight: 700,
                    cursor: isUploadProceedDisabled ? 'not-allowed' : 'pointer',
                    boxShadow: '0px 4px 24px rgba(157,79,26,0.36)',
                    transition: 'background 0.2s',
                    letterSpacing: 0.3,
                    opacity: isUploadProceedDisabled ? 0.5 : 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 8,
                    height: '56px',
                  }}
                >
                  Proceed
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12h14M13 6l6 6-6 6" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
              </>
            )}
          </div>
        </>
      )}

      {transactions.length === 0 && (
        <div style={{ ...styles.card, marginTop: 24 }}>

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, alignItems: 'center', marginBottom: 20 }}>
            {/* <button
              onClick={searchBulkUploadDocs}
              disabled={searchLoading}
              style={{ ...styles.historyBtn, opacity: searchLoading ? 0.6 : 1 }}
            >
              {searchLoading ? 'Searching…' : 'History Report'}
            </button> */}
          </div>

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'center', marginBottom: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 13, fontWeight: 500, color: '#676F7D', whiteSpace: 'nowrap' }}>From Date:</span>
              <input type="date" value={fromDate} max={toDate} onKeyDown={(e) => e.preventDefault()}
                onChange={(e) => setFromDate(e.target.value)} style={styles.dateInput} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 13, fontWeight: 500, color: '#676F7D', whiteSpace: 'nowrap' }}>To Date:</span>
              <input type="date" value={toDate} min={fromDate} max={formatDate(today)} onKeyDown={(e) => e.preventDefault()}
                onChange={(e) => setToDate(e.target.value)} style={styles.dateInput} />
            </div>

            <div style={{ position: 'relative' }}>
              <svg style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)' }} width="16" height="16" viewBox="0 0 24 24" fill="none">
                <circle cx="11" cy="11" r="8" stroke="#9CA3AF" strokeWidth="2" />
                <path d="M21 21l-4.35-4.35" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" />
              </svg>
              <input
                type="text"
                placeholder="Search By File Name..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{ ...styles.searchInput, paddingLeft: 38, width: '220px', boxSizing: 'border-box' }}
              />
            </div>


            <button onClick={searchBulkUploadDocs} disabled={searchLoading}
              style={{ ...styles.searchBtn, opacity: searchLoading ? 0.6 : 1 }}>
              {searchLoading ? 'Searching…' : 'Search'}
            </button>
          </div>

          {(() => {
            // const filtered = bulkUploadDocuments.filter(
            //   (doc) => !searchQuery || doc.document?.toLowerCase().includes(searchQuery.toLowerCase()),
            // );
            const filtered = bulkUploadDocuments;
            const totalDocPages = Math.ceil(filtered.length / DOCS_PAGE_SIZE);
            const visible = filtered.slice((docsPage - 1) * DOCS_PAGE_SIZE, docsPage * DOCS_PAGE_SIZE);

            return filtered.length > 0 ? (
              <div>
                {visible.map((doc, index) => {
                  const d = new Date(doc.created_at);
                  const dateStr = `${d.toLocaleString('default', { month: 'short' })} ${d.getDate()} at ${d.getHours()}:${String(d.getMinutes()).padStart(2, '0')} ${d.getHours() >= 12 ? 'PM' : 'AM'}`;
                  return (
                    <div key={index} style={styles.fileRow}>
                      <div style={styles.fileIcon}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="#155DFC" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          <polyline points="14,2 14,8 20,8" stroke="#155DFC" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          <line x1="16" y1="13" x2="8" y2="13" stroke="#155DFC" strokeWidth="1.5" strokeLinecap="round" />
                          <line x1="16" y1="17" x2="8" y2="17" stroke="#155DFC" strokeWidth="1.5" strokeLinecap="round" />
                        </svg>
                      </div>

                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 14, fontWeight: 600, color: '#1D2338', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {doc.document}
                        </div>
                        <div style={styles.dateLbl}>{dateStr}</div>
                        {doc.id && <span style={styles.idLbl}>ID: {doc.id}</span>}
                      </div>

                      <select
                        style={{ padding: '6px 10px', border: '1px solid #E6E5E5', borderRadius: 8, fontSize: 13, color: '#1D2338', background: '#FCFCFC', outline: 'none' }}
                        onChange={(e) => setDropDownStatus(e.target.value)}
                        defaultValue="all"
                      >
                        <option value="all">All</option>
                        {Constants.BULK_UPLOAD_TRANSACTION_STATUS?.map((s, i) => (
                          <option key={i} value={s}>{s}</option>
                        ))}
                      </select>

                      <button
                        onClick={() => downloadDocument(doc.id)}
                        disabled={downloadId === doc.id && downloadLoading}
                        style={{
                          background: 'none', border: 'none', cursor: 'pointer', padding: 6,
                          opacity: downloadId === doc.id && downloadLoading ? 0.4 : 1,
                        }}
                        title="Download"
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                          <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="#0B214E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          <polyline points="7,10 12,15 17,10" stroke="#0B214E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          <line x1="12" y1="15" x2="12" y2="3" stroke="#0B214E" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                      </button>
                    </div>
                  );
                })}

                {totalDocPages > 1 && (
                  <PaginationControls
                    currentPage={docsPage}
                    totalPages={totalDocPages}
                    onPageChange={setDocsPage}
                  />
                )}
              </div>
            ) : (
              searchPerformed && (
                <p style={{ textAlign: 'center', color: '#9CA3AF', padding: '32px 0', fontWeight: 600 }}>
                  No records found
                </p>
              )
            );
          })()}
        </div>
      )}
    </div>
  );
}

export default BulkUpload;
